export { default as CoreTableCaption } from './Caption';
export { default as CoreTableConsumer } from './Consumer';
export { default as CoreTableBody } from './Body';
export { default as CoreTableEmpty } from './Empty';
export { default as CoreTableFooter } from './Footer';
export { default as CoreTableHead } from './Head';
export { default as CoreTableSearch } from './Search';
export { default as CoreTableSync } from './Sync';
